import {
  ASSOCIATE_DIRECTOR,
  COACH,
  DIRECTOR,
  EXECUTIVE_DIRECTOR,
  GLOBAL_DIRECTOR,
  INTEGRATED_EXECUTIVE_DIRECTOR,
  INTEGRATED_GLOBAL_DIRECTOR,
  INTEGRATED_NATIONAL_DIRECTOR,
  INTEGRATED_PRESIDENTIAL_DIRECTOR,
  INTEGRATED_REGIONAL_DIRECTOR,
  MANAGER,
  NATIONAL_DIRECTOR,
  PRESIDENTIAL_DIRECTOR,
  REGIONAL_DIRECTOR,
  SENIOR_COACH,
} from '/enum/rank.enum';

export const RANK_ICON_NAME = {
  [COACH]: 'rank-1',
  [SENIOR_COACH]: 'rank-2',
  [MANAGER]: 'rank-3',
  [ASSOCIATE_DIRECTOR]: 'rank-4',
  [DIRECTOR]: 'rank-5',
  [EXECUTIVE_DIRECTOR]: 'rank-6',
  [INTEGRATED_EXECUTIVE_DIRECTOR]: 'rank-7',
  [REGIONAL_DIRECTOR]: 'rank-8',
  [INTEGRATED_REGIONAL_DIRECTOR]: 'rank-9',
  [NATIONAL_DIRECTOR]: 'rank-10',
  [INTEGRATED_NATIONAL_DIRECTOR]: 'rank-11',
  [GLOBAL_DIRECTOR]: 'rank-12',
  [INTEGRATED_GLOBAL_DIRECTOR]: 'rank-13',
  [PRESIDENTIAL_DIRECTOR]: 'rank-14',
  [INTEGRATED_PRESIDENTIAL_DIRECTOR]: 'rank-15',
};

export const SHIELD_WIDTH = 30;
export const SHIELD_HEIGHT = 36;
